import Image from "./images/light.png";
import Logo from "./images/logo-main.png";
import bg from "./images/bg.png";
const Home = () => {
  return (
    <header className="home">
      <nav>
        <div className="logo">
          <img src={Logo} alt="Death Note" />
        </div>
      </nav>
      <div className="container home-container">
        <div className="home-left">
          <div className="home-bg">
            <img src={bg} alt="" />
          </div>
          <div className="desc">
            <p>
              Light Yagami, the protagonist of "Death Note," discovers a
              supernatural notebook that grants him the power to kill by writing
              names in it. With a desire to create a crime-free world, he
              becomes the vigilante Kira, eliminating criminals. As his power
              and influence grow, he becomes consumed by his god-like status,
              resorting to manipulation and murder. He engages in a
              psychological battle with the detective L, who aims to expose
              Kira's identity. Light's character evolves from an idealistic
              figure into a morally ambiguous and power-hungry individual. His
              obsession with control leads to his downfall, highlighting the
              consequences of his actions and the toll on his psyche.
            </p>
          </div>
          <div className="name">
            <h1>
              Light Yagami <br /> (夜神月)
            </h1>
          </div>
        </div>
        <div className="home-right">
          <div className="home-image">
            <img src={Image} alt="Light Yagami" />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Home;
